export default __webpack_public_path__ + "3b42b817a50d0d6aba1b24dc71e0ed2a.svg";